// components/PitchDeck/10_TheAsk.jsx
import React from 'react';

export default function TheAsk() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#4285F4] to-blue-900 text-white py-20">
            <div className="text-center max-w-4xl mx-auto px-6">
                <h2 className="text-5xl md:text-7xl font-bold mb-12">
                    The Ask
                </h2>
                <p className="text-4xl font-semibold mb-8">
                    $50,000 for 15% Equity
                </p>
                <p className="text-2xl mb-16">
                    Fuel marketing, customer acquisition, V2 features, and regulatory compliance to hit 10–15 customers in 6 months and seed follow-on within 12 months.
                </p>
                <p className="text-3xl font-bold">
                    Join us in building the financial backbone for Nigeria's SMEs.
                </p>
                <div className="flex flex-col items-end">
                    <p className="text-xl mt-8 opacity-90">
                        Contact: James Oyewale
                    </p>
                    <p className="text-xl mt-2 opacity-90"> 📧 arxistechnologies@gmail.com • ☎️ +234 916 449 5789)
                    </p>
                    <p className="text-xl mt-2 opacity-90">  Lagos, Nigeria
                    </p>
                </div>
            </div>
        </div>
    );
}